export default "__VITE_ASSET__BQ9MyGzU__"